import { AnimatePresence } from 'framer-motion';
import { Route, Routes, useLocation } from 'react-router-dom';

import { MainLayout } from '@app/layout/MainLayout';
import { RequireAuth } from './RequireAuth';
import { AuthenticatedLayout } from '@app/layout/AuthenticatedLayout';
import { GuestOnly } from './GuestOnly';
import { GuestLayout } from '@app/layout/GuestLayout';
import { AdminRoutes } from './AdminRoutes';
import { UserRoutes } from './UserRoutes';
import AuthPage from '@app/pages/AuthPage';
import ServerErrorPage from '@app/pages/ServerErrorPage';
import { Page } from '@app/routes';
import { PageAnimator } from '@app/layout/PageAnimator';

export default function AppRouter() {
  const location = useLocation();

  return (
    <AnimatePresence mode="popLayout">
      <Routes location={location} key={location.pathname}>
        <Route element={<PageAnimator />}>
          <Route element={<MainLayout />}>
            <Route element={<RequireAuth />}>
              <Route element={<AuthenticatedLayout />}>
                {AdminRoutes}
                {UserRoutes}
              </Route>
            </Route>
            <Route element={<GuestOnly />}>
              <Route element={<GuestLayout />}>
                <Route path={Page.AUTH} element={<AuthPage />} />
              </Route>
            </Route>
            <Route path="*" element={<ServerErrorPage />} />
          </Route>
        </Route>
      </Routes>
    </AnimatePresence>
  );
}
